module.exports = __webpack_public_path__ + "media/images/leaf-bbfdc3ec7fb091ecafa47f31b8b51afd.jpg";